"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelFieldText = exports.ModelMutatorText = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var collection_field_1 = require("../collection.field");
var ModelMutatorText = /** @class */ (function (_super) {
    tslib_1.__extends(ModelMutatorText, _super);
    function ModelMutatorText() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ModelMutatorText.prototype.manual = function (newText) {
        if (newText == null || newText.length === 0) {
            this.state.setFieldValue(this.field.id, null);
        }
        else {
            this.state.setFieldValue(this.field.id, newText);
        }
    };
    ModelMutatorText.prototype.copy = function (from) {
        // Cannot use super.copy. See TODO above
        this.manual(from.value);
        return true;
    };
    return ModelMutatorText;
}(collection_field_1.ModelMutator));
exports.ModelMutatorText = ModelMutatorText;
var CollectionModelFieldText = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModelFieldText, _super);
    function CollectionModelFieldText() {
        var _this = _super.apply(this, tslib_1.__spreadArray([], tslib_1.__read(arguments), false)) || this;
        _this._Mutator = new ModelMutatorText(_this);
        return _this;
    }
    CollectionModelFieldText.isTextField = function (f) {
        return f.schema.type === CollectionModelFieldText.TYPE;
    };
    Object.defineProperty(CollectionModelFieldText.prototype, "Mutator", {
        get: function () {
            if (this._Mutator == null) {
                this._Mutator = new ModelMutatorText(this);
            }
            return this._Mutator;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldText.prototype, "value", {
        get: function () {
            return this.stateValue || '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldText.prototype, "displayValue", {
        get: function () {
            var stateValue = this.stateValue;
            if (stateValue == null) {
                return '';
            }
            return stateValue || '';
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelFieldText.prototype.hasValue = function () {
        var value = this.value;
        if (value == null || value === '') {
            return false;
        }
        return true;
    };
    CollectionModelFieldText.TYPE = core_api_1.IkeFieldType.TEXT;
    return CollectionModelFieldText;
}(collection_field_1.CollectionModelField));
exports.CollectionModelFieldText = CollectionModelFieldText;
//# sourceMappingURL=text.field.js.map